import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import { THAI_PROVINCES, THAI_DISTRICTS, THAI_SUB_DISTRICTS } from '../../constants';
import validate from 'validate.js';
import _ from 'lodash';
import './address.css';
import { sortCompare } from '../../utils/'

const pattern = { taxId: /\d{13}/, zipCode: /\d{5}/, phoneNumber: /\d{10}/ };

const validateChangeAddress = {
    name: {
        presence: { allowEmpty: false, message: 'is required' }
    },
    lastName: {
        presence: { allowEmpty: false, message: 'is required' }
    },
    phoneNumber: {
        presence: { allowEmpty: false, message: 'is required' },
        numericality: { onlyInteger: true },
        format: pattern.phoneNumber
    },
    zipCode: {
        presence: { allowEmpty: false, message: 'is required' },
        // numericality: { onlyInteger: true },
        // format: pattern.zipCode
    },
    address: {
        presence: { allowEmpty: false, message: 'is required' }
    }
};

const jstrProvince = JSON.stringify({
    PROVINCE_ID: 0,
    PROVINCE_NAME: 'default'
});

const jstrDistrict = JSON.stringify({
    DISTRICT_ID: 0,
    DISTRICT_NAME: 'default'
});

const jstrSubDistrict = JSON.stringify({
    SUB_DISTRICT_ID: 0,
    SUB_DISTRICT_NAME: 'default',
    ZIP_CODE: ''
});

class DialogEditAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            values: {},
            touched: {},
            errors: {},
            ST_THAI_DISTRICTS: THAI_DISTRICTS,
            ST_THAI_SUB_DISTRICTS: THAI_SUB_DISTRICTS
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.dialogEditAddress, this.props.dialogEditAddress) && this.props.dialogEditAddress )
        {
            const {
                name,
                lastName,
                phoneNumber,
                email,
                address,
                district,
                subDistrict,
                province,
                zipCode,
                isDefault
            } = this.props.editSelected;
            const provFiltered = _.filter(THAI_PROVINCES, prov =>  prov.PROVINCE_NAME_TH === province || prov.PROVINCE_NAME_EN === province);
            const _province = {
                PROVINCE_ID: provFiltered[0].PROVINCE_ID,
                PROVINCE_NAME: provFiltered[0].PROVINCE_NAME_TH,
            };

            const NEW_THAI_DISTRICTS =
                _province.PROVINCE_NAME === jstrProvince
                    ? THAI_DISTRICTS
                    : _.filter(THAI_DISTRICTS, dis => dis.PROVINCE_ID === _province.PROVINCE_ID);

            const distFiltered = _.filter(THAI_DISTRICTS, dist =>  dist.DISTRICT_NAME_TH === district || dist.DISTRICT_NAME_EN === district); 
            const _district = {
                DISTRICT_ID: distFiltered[0].DISTRICT_ID,
                DISTRICT_NAME: distFiltered[0].DISTRICT_NAME_TH
            };

            const NEW_THAI_SUB_DISTRICTS =
                _province.DISTRICT_NAME === jstrDistrict
                    ? THAI_DISTRICTS
                    : _.filter(THAI_SUB_DISTRICTS, subDis => subDis.DISTRICT_ID === _district.DISTRICT_ID);

            const subDistFiltered = _.filter(THAI_SUB_DISTRICTS, subDist => _district.DISTRICT_ID ===subDist.DISTRICT_ID && (subDist.SUB_DISTRICT_NAME_TH === subDistrict || subDist.SUB_DISTRICT_NAME_EN === subDistrict)); 
            const _subDistrict = !subDistFiltered || !subDistFiltered.length
                ? JSON.parse(jstrSubDistrict)
                : {
                    SUB_DISTRICT_ID: subDistFiltered[0].SUB_DISTRICT_ID,
                    SUB_DISTRICT_NAME: subDistFiltered[0].SUB_DISTRICT_NAME_TH,
                    ZIP_CODE: subDistFiltered[0].ZIP_CODE
                };

            this.setState(prevSt => ({
                ...prevSt,
                values: {
                    name,
                    lastName,
                    email,
                    phoneNumber,
                    address,
                    province: JSON.stringify(_province),
                    district: JSON.stringify(_district),
                    subDistrict: JSON.stringify(_subDistrict),
                    zipCode,
                    isDefault
                },
                ST_THAI_DISTRICTS: NEW_THAI_DISTRICTS,
                ST_THAI_SUB_DISTRICTS: NEW_THAI_SUB_DISTRICTS
            }));
        }

        if (!_.isEqual(prevState.values, this.state.values)) {
            const { values } = this.state;
            const errors = validate(values, validateChangeAddress);

            const isValid = !errors;

            const _isValid =
                isValid === true 
                && values.province !== jstrProvince 
                && values.district !== jstrDistrict
                && values.subDistrict !== jstrSubDistrict;

            this.setState(prevSt => ({
                ...prevSt,
                isValid: _isValid,
                errors: errors || {}
            }));
        }
    }

    handleAddressChange = event => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            ...prevState,
            values: { ...prevState.values, [name]: value },
            touched: { ...prevState.touched, [name]: true }
        }));
    };

    handleSelectProvinceChange = value => {
        const { PROVINCE_ID, PROVINCE_NAME } = JSON.parse(value);
        const NEW_THAI_DISTRICTS = PROVINCE_NAME === 'default' ? THAI_DISTRICTS : _.filter(THAI_DISTRICTS, dis => dis.PROVINCE_ID === PROVINCE_ID);
        this.setState(prevState => ({
            ...prevState,
            values: { ...prevState.values, province: value, district: jstrDistrict, subDistrict: jstrSubDistrict, zipCode:'' },
            ST_THAI_DISTRICTS: NEW_THAI_DISTRICTS
        }));
    };

    handleSelectDistrictChange = value => {
        const { DISTRICT_ID, DISTRICT_NAME } = JSON.parse(value);
        const NEW_THAI_SUB_DISTRICTS = DISTRICT_NAME === 'default' ? THAI_SUB_DISTRICTS : _.filter(THAI_SUB_DISTRICTS, dis => dis.DISTRICT_ID === DISTRICT_ID);
        this.setState(prevState => ({
            ...prevState,
            values: { ...prevState.values, district: value, subDistrict: jstrSubDistrict, zipCode:''  },
            ST_THAI_SUB_DISTRICTS: NEW_THAI_SUB_DISTRICTS
        }));
    };

    handleSelectSubDistrictChange = value => {
        var subDistrict =  JSON.parse(value);
        this.setState(prevState => ({
            ...prevState,
            values: { ...prevState.values, subDistrict: value, zipCode:  subDistrict.ZIP_CODE  },
        }));
    };
    canSelectDistrict = () => this.state.values.province !== jstrProvince;
    canSelectSubDistrict = () => this.state.values.district !== jstrDistrict;

    hasError = field => this.state.touched[field] && this.state.errors[field];

    render() {
        const { values, errors, isValid, ST_THAI_DISTRICTS, ST_THAI_SUB_DISTRICTS } = this.state;

        const { wording, dialogEditAddress, EditAddress, CloseDialogEditAddress } = this.props;

        return (
            <Modal
                visible={dialogEditAddress}
                width='450'
                effect='fadeInUp'
                onClickAway={() => CloseDialogEditAddress()}>
                <div className='m-20'>
                    <div className='dialog-header'>
                        <h4 style={{ color: '#2d64cf' }}>
                            {wording.usermenu.address.dialogShippingAddress.titleChange}
                        </h4>
                    </div>

                    <div className='dialog-body address mt-20 mb-20'>
                        <input
                            className='form-color'
                            name='name'
                            type='text'
                            placeholder={wording.usermenu.address.dialogShippingAddress.name}
                            value={values.name || ''}
                            onChange={this.handleAddressChange}
                        />
                        {this.hasError('name') ? <p className='error'>{errors.name[0]}</p> : null}

                        <input
                            name='lastName'
                            type='text'
                            placeholder={wording.usermenu.address.dialogShippingAddress.lastName}
                            value={values.lastName || ''}
                            onChange={this.handleAddressChange}
                        />
                        {this.hasError('lastName') ? <p className='error'>{errors.lastName[0]}</p> : null}

                        <input
                            name='address'
                            type='text'
                            placeholder={wording.usermenu.address.dialogShippingAddress.address}
                            value={values.address || ''}
                            onChange={this.handleAddressChange}
                        />
                        {this.hasError('address') ? <p className='error'>{errors.address[0]}</p> : null}

                        <p className='select-option form-row form-row-wide'>
                            <select
                                name='province'
                                className='country_to_state province_select'
                                onChange={e => this.handleSelectProvinceChange(e.target.value)}
                                value={values.province}>
                                <option value={jstrProvince}>{wording.usermenu.address.dialogShippingAddress.province}</option>

                                {THAI_PROVINCES.map(prov => {
                                    const value = JSON.stringify({
                                        PROVINCE_ID: prov.PROVINCE_ID,
                                        PROVINCE_NAME: prov.PROVINCE_NAME_TH
                                    });

                                    return (
                                        <option key={prov.PROVINCE_ID} value={value}>
                                            {`${prov.PROVINCE_NAME_TH}/${prov.PROVINCE_NAME_EN}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </p>

                        <p className='select-option form-row form-row-wide'>
                            <select
                                className='country_to_state province_select'
                                disabled={!this.canSelectDistrict()}
                                onChange={e => this.handleSelectDistrictChange(e.target.value)}
                                value={values.district}>
                                <option value={jstrDistrict}>{wording.usermenu.address.dialogShippingAddress.district}</option>

                                {sortCompare(ST_THAI_DISTRICTS, "DISTRICT_NAME_TH").map(dist => {
                                    const value = JSON.stringify({
                                        DISTRICT_ID: dist.DISTRICT_ID,
                                        DISTRICT_NAME: dist.DISTRICT_NAME_TH
                                    });
                                    return (
                                        <option key={dist.DISTRICT_ID} value={value}>
                                            {`${dist.DISTRICT_NAME_TH}/${dist.DISTRICT_NAME_EN}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </p>

                        <p className='select-option form-row form-row-wide'>
                            <select
                                className='country_to_state province_select'
                                disabled={!this.canSelectSubDistrict()}
                                onChange={e => this.handleSelectSubDistrictChange(e.target.value)}
                                value={values.subDistrict}>
                                <option value={jstrSubDistrict}>{wording.usermenu.address.dialogShippingAddress.subDistrict}</option>
                                {sortCompare(ST_THAI_SUB_DISTRICTS, "SUB_DISTRICT_NAME_TH").map(subdist => {
                                    const value = JSON.stringify({
                                        SUB_DISTRICT_ID: subdist.SUB_DISTRICT_ID,
                                        SUB_DISTRICT_NAME: subdist.SUB_DISTRICT_NAME_TH,
                                        ZIP_CODE: subdist.ZIP_CODE
                                    });
                                    return (
                                        <option key={subdist.SUB_DISTRICT_ID} value={value}>
                                            {`${subdist.SUB_DISTRICT_NAME_TH}/${subdist.SUB_DISTRICT_NAME_EN}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </p>

                        <input
                            name='zipCode'
                            type='text'
                            placeholder={wording.usermenu.address.dialogShippingAddress.zipcode}
                            maxLength='5'
                            value={values.zipCode || ''}
                            disabled
                            onChange={this.handleAddressChange}
                        />
                        {this.hasError('zipCode') ? <p className='error'>{errors.zipCode[0]}</p> : null}

                        <input
                            name='phoneNumber'
                            type='text'
                            maxLength='10'
                            placeholder={wording.usermenu.address.dialogShippingAddress.phoneNumber}
                            value={values.phoneNumber || ''}
                            onChange={this.handleAddressChange}
                        />
                        {this.hasError('phoneNumber') ? <p className='error'>{errors.phoneNumber[0]}</p> : null}
                    </div>

                    <div className='dialog-action row'>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-dark'
                                disabled={!isValid}
                                onClick={() => {
                                    // CloseDialogEditAddress();
                                    console.log(values);
                                    EditAddress(values);
                                }}>
                                {wording.usermenu.address.dialogShippingAddress.ok}
                            </button>
                        </div>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-light-red'
                                onClick={() => CloseDialogEditAddress()}>
                                {wording.usermenu.address.dialogShippingAddress.cancle}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ address, language }) => ({
    wording: language.wording,
    dialogEditAddress: address.dialogEditAddress,
    editSelected: address.editSelected?.value
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CloseDialogEditAddress: Actions.CloseDialogEditAddress,
            EditAddress: Actions.EditAddress
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogEditAddress);
